import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ImageComtainer,
  InfoComtainer,
  InfoTitle,
} from './style';
import Detail from './Detail';
import unit_institution from "../../../store/asset_institution/unit_institution";
import unit_institution_mechanismSelection from "../../../store/asset_institution/unit_institution_mechanismSelection";
import { webviewRedirect } from '../../../utils/tool';

class MechanismSelectionItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  gotoItemPage(id) {
    // 跳转机构选聘详情页
    const {setTabIndex} = unit_institution;
    const {setAssetPromotionData} = unit_institution_mechanismSelection;
    setAssetPromotionData();
    setTabIndex();
    webviewRedirect(`//pcxp.m.jd.com/xpdetail?id=${id}`)
  }

  getImgUrl=(completeUrl, legacyUrl)=>{
    if (legacyUrl && legacyUrl.indexOf('http') === -1 && legacyUrl.indexOf('//') === -1 && legacyUrl.indexOf('jfs') > -1) {
      return `https://img12.360buyimg.com/img${legacyUrl}!cc_260x260`
    }
    if (completeUrl) return completeUrl
    if (legacyUrl) {
      if (legacyUrl.indexOf('http') === -1 && legacyUrl.indexOf('//') === -1) {
        return `https://storage.jd.com/pharos-court/${legacyUrl}`
      }
      return legacyUrl
    }
    return ''
  }

  render() {
    const {itemInfo} = this.props;
    const {announcementStatus,completeMainImgUrl,mainImgUrl,id,announcementTitle} = this.props.itemInfo;
    const MAP_MERCHANTS_STATUS = {
      10: {
        TEXT:'待发布'
      },
      20: {
        TEXT:'公告中'
      },
      30: {
        TEXT:'公告结束'
      },
      40: {
        TEXT:'公告中止'
      }
    };
    return (
      <ItemContainer onClick={() => {
        this.gotoItemPage(id);
      }}>
        <ImageComtainer>
          <i className={`icon-corner-sign ${announcementStatus === 30 || announcementStatus === 40?'over':''}`}>{announcementStatus && MAP_MERCHANTS_STATUS[announcementStatus].TEXT}</i>
          <img src={this.getImgUrl(completeMainImgUrl, mainImgUrl)}/>
        </ImageComtainer>
        <InfoComtainer>
          <InfoTitle>{announcementTitle}</InfoTitle>
          <Detail itemInfo={itemInfo}></Detail>
        </InfoComtainer>
      </ItemContainer>
    )
  }
}

export default MechanismSelectionItem;
